export default function Contact() {
  return (
    <section id="contact" className="w-full py-14 md:py-18 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            联系我们
          </h2>
          <p className="text-foreground-600 text-sm mt-2">如有任何问题或建议，欢迎通过以下方式与我们取得联系</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center cursor-default">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 text-2xl mx-auto mb-3">
              <i className="ri-mail-line"></i>
            </span>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">邮箱联系</h3>
            <p className="text-sm text-foreground-500">feedback@wumacinema.com</p>
          </div>

          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center cursor-default">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 text-2xl mx-auto mb-3">
              <i className="ri-chat-3-line"></i>
            </span>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">意见反馈</h3>
            <p className="text-sm text-foreground-500">在线提交反馈表单</p>
          </div>

          <div className="bg-background-50 rounded-xl p-5 border border-background-200/60 text-center cursor-default">
            <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 text-2xl mx-auto mb-3">
              <i className="ri-team-line"></i>
            </span>
            <h3 className="font-heading text-base font-bold text-foreground-900 mb-1">商务合作</h3>
            <p className="text-sm text-foreground-500">partner@wumacinema.com</p>
          </div>
        </div>

        <div className="bg-background-50 rounded-xl p-6 border border-background-200/60">
          <h3 className="font-heading text-base font-bold text-foreground-900 mb-4 text-center">在线留言</h3>
          <form className="space-y-4 max-w-lg mx-auto" onSubmit={(e) => e.preventDefault()}>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <input
                type="text"
                name="name"
                placeholder="您的称呼"
                className="w-full px-4 py-2.5 rounded-lg border border-background-200/60 bg-background-100 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
              />
              <input
                type="email"
                name="email"
                placeholder="电子邮箱"
                className="w-full px-4 py-2.5 rounded-lg border border-background-200/60 bg-background-100 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
              />
            </div>
            <textarea
              name="message"
              placeholder="请输入您的留言内容（限500字）"
              maxLength={500}
              rows={4}
              className="w-full px-4 py-2.5 rounded-lg border border-background-200/60 bg-background-100 text-sm text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors resize-none"
            ></textarea>
            <div className="text-center">
              <button
                type="submit"
                className="px-8 py-2.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
              >
                提交留言
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}